import common from '@/sui/sc/helps/common'

export default [
  common.disciplines
]
